<!-- 联系我们 -->
<template>
  <div class="contact_page">
    <div class="contact_header">
      <titleBox :title="$t('message.contact.title')"></titleBox>
    </div>
    <div class="content">
      <el-form
        class="form"
        ref="form"
        :model="params"
        :label-width="formLabelWidth"
        :label-position="formLabelPosition"
      >
        <el-form-item
          :label="$t('message.contact.form.name')"
          prop="name"
          :rules="{
            required: true,
            message: $t('message.contact.form.nameError'),
          }"
        >
          <el-input class="ipt" v-model="params.name"></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('message.contact.form.email')"
          prop="email"
          :rules="{
            required: true,
            message: $t('message.contact.form.emailError'),
          }"
        >
          <el-input class="ipt" v-model="params.email"></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('message.contact.form.companyName')"
          prop="companyName"
          :rules="{
            required: true,
            message: $t('message.contact.form.companyNameError'),
          }"
        >
          <el-input class="ipt" v-model="params.companyName"></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('message.contact.form.mobile')"
          prop="mobile"
          :rules="{
            required: true,
            message: $t('message.contact.form.mobileError'),
          }"
        >
          <el-input class="ipt" v-model="params.mobile"></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('message.contact.form.consultText')"
          prop="consultationContent"
          :rules="{
            required: true,
            message: $t('message.contact.form.consultTextError'),
          }"
        >
          <el-input
            class="ipt"
            type="textarea"
            rows="5"
            v-model="params.consultationContent"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('message.contact.form.code')"
          prop="code"
          :rules="[
            {
              required: true,
              message: $t('message.contact.form.codeError'),
            },
            {
              validator: this.checkCode,
              message: $t('message.contact.form.codeError'),
            },
          ]"
        >
          <div class="code-box">
            <el-input class="code" v-model="params.code"></el-input>
            <div id="code">{{ code }}</div>
            <span class="change" @click="changeCode">{{
              $t("message.contact.change")
            }}</span>
          </div>
        </el-form-item>
        <el-form-item class="submit_item">
          <button class="form_btn" type="button" @click="submitContact">
            {{ $t("message.contact.btnText") }}
          </button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      formLabelWidth: "10em",
      formLabelPosition: "right",
      params: {
        name: "",
        email: "",
        companyName: "",
        mobile: "",
        consultationContent: "",
        code: "",
      },
      codeList: [],
      code: "",
    };
  },
  created() {},
  mounted() {
    this.creatCode();
    this.updateFormLabelWidth();
    window.addEventListener("resize", this.updateFormLabelWidth);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateFormLabelWidth);
  },
  methods: {
    updateFormLabelWidth() {
      const isMobile = window.innerWidth <= 768;
      this.formLabelWidth = isMobile ? "0" : "10em";
      this.formLabelPosition = isMobile ? "top" : "right";
    },
    checkCode(r, v, cb) {
      if (v != this.code) {
        cb(new Error());
      } else {
        cb();
      }
    },
    creatCode() {
      let charStr = "abcdefghijklmnopqrstuvwxyz0123456789";
      var chars = charStr.split("");
      var randCode = "";
      for (var i = 0; i < 4; i++) {
        var randPosition = Math.floor(Math.random() * (chars.length - 1));
        randCode += chars[randPosition];
      }
      this.code = randCode;
    },
    changeCode() {
      this.creatCode();
    },
    submitContact() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$api.addContact(this.params).then((res) => {
            if (res.code == 0) {
              this.$notify.success({
                title: "success!",
              });
              setTimeout(() => {
                Object.assign(this.$data.params, this.$options.data().params);
                this.$refs.form.clearValidate();
              }, 1000);
            } else {
              this.$notify.error({
                title: res.msg,
              });
            }
          });
        }
      });
    },
  },
};
</script>
<style lang='scss' scoped>
.contact_page {
  position: relative;
  background-image: url("../assets/last_page_bg.jpeg");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center top;

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    background-color: rgba(0, 0, 0, 0.2);
    pointer-events: none;
    z-index: 0;
  }

  .contact_header,
  .content {
    position: relative;
    z-index: 1;
  }

  @include respond-md {
    background-attachment: scroll;
  }
}

.contact_header {
  ::v-deep .title_box {
    height: 280px;
    padding-top: 108px;
    background-color: transparent;

    .title {
      color: #fff;
      text-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);
    }
  }
}

.content {
  width: 1200px;
  margin: 0 auto 60px;
  font-size: 14px;

  .form {
    width: 800px;
    margin: 0 auto;
    padding: 40px 50px 30px;
    background-color: rgba(255, 255, 255, 0.95);
    border-radius: 4px;
    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.12);
  }
  .form_btn {
    display: block;
    width: 245px;
    height: 45px;
    margin: 0 auto;
    text-align: center;
    line-height: 45px;
    font-size: 14px;
    letter-spacing: 1px;
    background-image: url("../assets/btnStyle.png");
    color: #fff;
    border: none;
    cursor: pointer;
    font-weight: bold;

    &:active {
      transform: scale(0.9);
    }
  }

  .submit_item {
    ::v-deep .el-form-item__content {
      margin-left: 0 !important;
      text-align: center;
    }
  }
  .ipt {
    width: 530px;
  }

  .code-box {
    display: flex;
    align-items: center;
  }

  .code {
    width: 130px;
  }
  #code {
    width: 80px;
    height: 30px;
    font-size: 18px;
    line-height: 30px;
    text-align: center;
    color: #333;
    background-color: #6495ed;
    margin: 0 20px;
    cursor: pointer;
    user-select: none;
  }
  .change {
    cursor: pointer;
    line-height: 36px;
    float: left;
    font-size: 16px;
    color: rgb(102, 102, 102);
    user-select: none;
  }
}

@include respond-md {
  .contact_page {
    background-size: cover;
    background-position: center top;
  }

  .content {
    width: 100%;
    max-width: 1200px;
    padding: 0 16px;
    margin-bottom: 32px;

    .form {
      width: 100%;
      max-width: 800px;
      padding: 20px 16px 24px;
      border-radius: 8px;

      ::v-deep .el-form-item {
        margin-bottom: 18px;
      }

      ::v-deep .el-form-item__label {
        float: none;
        display: block;
        text-align: left;
        line-height: 1.4;
        padding: 0 0 6px;
        font-size: 14px;
        color: #333;
      }

      ::v-deep .el-form-item__content {
        margin-left: 0 !important;
      }

      ::v-deep .el-input__inner,
      ::v-deep .el-textarea__inner {
        font-size: 16px;
      }
    }

    .ipt {
      width: 100%;
    }

    .code-box {
      flex-wrap: wrap;
      align-items: center;
      gap: 10px;
      width: 100%;
    }

    .code {
      flex: 1;
      min-width: 100px;
      max-width: 140px;
    }

    #code {
      margin: 0;
      flex-shrink: 0;
    }

    .change {
      float: none;
      font-size: 14px;
      line-height: 1.4;
    }

    .form_btn {
      width: 100%;
      max-width: none;
      height: 48px;
      line-height: 48px;
      font-size: 15px;
    }
  }

  .contact_header {
    ::v-deep .title_box {
      height: 140px;
      padding-top: 48px;

      .title {
        font-size: 24px;
      }
    }
  }
}

@include respond-sm {
  .contact_page {
    background-size: cover;
    background-position: center 20%;
  }

  .contact_header {
    ::v-deep .title_box {
      height: 120px;
      padding-top: 40px;

      .title {
        font-size: 22px;
      }
    }
  }

  .content {
    padding: 0 12px;
    margin-bottom: 24px;

    .form {
      padding: 16px 14px 20px;

      ::v-deep .el-form-item {
        margin-bottom: 14px;
      }

      ::v-deep .el-textarea__inner {
        min-height: 100px !important;
      }
    }

    .code-box {
      display: grid;
      grid-template-columns: 1fr auto;
      grid-template-areas:
        "input captcha"
        "change change";
      gap: 10px;
    }

    .code {
      grid-area: input;
      max-width: none;
      width: 100%;
    }

    #code {
      grid-area: captcha;
    }

    .change {
      grid-area: change;
    }
  }
}
</style>
